// @core/api/endpoints/apikey/list_api_keys.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAPIKeysResponse,
} from '../../../types/apikey';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/apikey';

/**
 * List API keys
 * Returns a paginated list of API keys for the tenant. Supports filtering by status, search term, and includes option to show expired keys.
 */
export async function ListAPIKeys(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAPIKeysResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/api-keys`;
  const requestOptions = options;
  return client.get<ListAPIKeysResponse>(requestPath, { ...requestOptions, params });
}
